<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-form @submit.prevent="toPagador" autocomplete="off" id="fpasajeros">
          <div v-if="showHotel">
            <v-card
              v-for="(h, indexh) in servicios.hoteles"
              v-bind:key="indexh"
            >
              <v-card-title primary-title class="mx-auto">
                <v-card-text class="pa-0">
                  <TituloInfoHotel
                    :in="h.in | formatDMY"
                    :out="h.out | formatDMY"
                    :diff="_$diffDias(h.in, h.out)"
                    :nombre="h.nombre"
                  >
                  </TituloInfoHotel>
                </v-card-text>
              </v-card-title>
              <v-card-text>
                <v-card
                  v-for="(hab, inhab) in h.habitaciones"
                  v-bind:key="inhab"
                  color="grey lighten-3"
                  class="mb-4"
                >
                  <p class="pt-4 text-xs-center font-weight-regular title">
                    {{ hab.habitacion.nombre }}
                  </p>
                  <Pasajeros
                    :adls="hab.habitacion.tarifas.tarifa['@attributes'].adl"
                    :checkin="h.in"
                    :edades="hab.habitacion.menores.edades.edad"
                    :belong="h.unico_carrito + '-' + inhab"
                    :showListPax="indexh != 0 ? true : false"
                    :tipoServicio="'h'"
                    :isDisney="h.destino === 'WDW'"
                  />
                </v-card>
              </v-card-text>
            </v-card>
          </div>
          <div v-if="!showHotel">
            <v-card
              v-for="(c, indexc) in servicios.cupos"
              class="my-2"
              v-bind:key="indexc"
            >
              <v-card-title primary-title class="mx-auto">
                <v-card-text class="pa-0">
                  <p
                    class="title font-weight-light text-uppercase mb-0 text-xs-center"
                  >
                    {{ c.descripcion }}
                  </p>
                </v-card-text>
              </v-card-title>
              <v-card-text>
                <v-card color="grey lighten-3">
                  <Pasajeros
                    :adls="c.totales.adl"
                    :checkin="c.ida[0].salida.fecha"
                    :edades="c.menores.edades"
                    :tipoServicio="'c'"
                  />
                </v-card>
              </v-card-text>
            </v-card>
          </div>
          <v-card
            v-for="(t, tinx) in servicios.tickets"
            class="mb-2"
            :key="tinx"
          >
            <v-card-title primary-title class="mx-auto">
              <v-card-text class="pa-0">
                <p
                  class="title font-weight-light text-uppercase mb-0 text-xs-center"
                >
                  {{ t.nombre }}
                </p>
                <p
                  class="body-2 font-weight-light text-uppercase mb-0 text-xs-center"
                >
                  {{ t.in | formatDMY }}
                </p>
              </v-card-text>
            </v-card-title>
            <v-card-text>
              <v-card color="grey lighten-3">
                <Pasajeros
                  :adls="t.tarifas.totales['@attributes'].adl"
                  :checkin="t.in"
                  :edades="
                    Array(parseInt(t.tarifas.totales['@attributes'].chd))
                  "
                  :tipoServicio="'t'"
                  :showListPax="showPaxSelectorTicket(tinx)"
                  :belong="t.unico_carrito"
                />
              </v-card>
            </v-card-text>
          </v-card>
          <b-row>
            <b-col cols="12" sm="3" class="pb-2">
              <v-btn type="submit" color="primary">CONTINUAR</v-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Carrito from "@/components/utiles/Carrito.vue";
import TituloInfoHotel from "@/components/utiles/TituloInfoHotel.vue";
import Pasajeros from "@/components/utiles/Pasajeros.vue";
import MapperReserva from "@/assets/js/class/MapperReserva.js";
import { mapGetters } from "vuex";
export default {
  name: "pasajerosCupoAgencias",
  components: {
    Carrito,
    Pasajeros,
    TituloInfoHotel
  },
  mounted() {},
  activated() {
    const boton = this._$toBotonCarrito(null, null, null, null, false);
    this.$store.dispatch("carrito/saveBoton", boton);
  },
  methods: {
    hayServicios() {
      const hay = Object.keys(this.servicios).some(item => {
        if (item === "tarifas") {
          return false;
        }
        return this.servicios[item].length === 0 ? false : true;
      });
      if (!hay) {
        this._$goToInicio();
        return;
      }
    },
    subtitle(checkin, checkout) {
      const cin = this.$options.filters.formatDMY(checkin);
      const cout = this.$options.filters.formatDMY(checkout);
      return `${cin} al ${cout}`;
    },
    async toPagador() {
      let _this = this;
      let promesas = await this.$children.map(async c => {
        let filtered = c.$children
          .map(c => {
            return c.$children.find(
              cc => cc.$options._componentTag === "Pasajeros"
            );
          })
          .filter(f => f != null);
        let mapped = await filtered.map(async function(c) {
          let valid = c.$validator.validateAll().then(result => {
            return { ok: result, form: c._data.form };
          });
          return Promise.resolve(valid);
        });
        return Promise.all(mapped);
      });
      Promise.all(promesas).then(values => {
        this.manejoCargaFormularios(values);
      });
    },
    cualServicio() {
      this.showHotel = this.servicios.hoteles.length > 0;
    },
    manejoCargaFormularios(formularios) {
      let _this = this;
      if (formularios.every(r => r.every(f => f.ok))) {
        this.formsOK(formularios);
        return;
      }
      this.showToasted(
        "Verifique que los formularios no tengan errores",
        "error"
      );
    },
    formsOK(formularios) {
      let name = "buscandox";
      const mapper = new MapperReserva(
        formularios,
        this.servicios,
        this.paxsToAsignar
      );
      const servicios = mapper.pax2Servicios();
      let data = this.armarParametros2Espera(servicios);
      if (this.usuario.nivel == 0) {
        name = "facturacion";
        data = servicios;
      }
      this.$router.push({ name: name, params: { data: data } });
    },
    armarParametros2Espera(servicios) {
      var methodData = this.completarBusqueda();
      var to = "facturacion";
      var redirect = {
        to: "inicio",
        mensaje: "Ocurrio un error, será redirigido al inicio."
      };
      var data2To = servicios;
      return {
        to: to,
        redirect: redirect,
        methodData: methodData,
        data2To: data2To,
        mensaje: "Espere por favor"
      };
    },
    completarBusqueda() {
      var methodData = {
        method: "GET",
        url: process.env.VUE_APP_ASBACK + "/api/entidades",
        data: null
      };
      return methodData;
    },
    showPaxSelectorTicket(indice) {
      if (this.servicios.hoteles.length > 0 || indice > 0) {
        return true;
      }
      return false;
    },
    init() {
      this.hayServicios();
      this.cualServicio();
    }
  },
  created() {},
  computed: {
    ...mapGetters("carrito", {
      servicios: "cartServicios",
      cantServicios: "getCantidadServicios"
    }),
    ...mapGetters("app", {
      usuario: "getUsuario"
    }),
    ...mapGetters("pasajeros", {
      paxsToAsignar: "getPaxToAsingar"
    })
  },
  data: function() {
    return {
      showHotel: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(_ => {
      if (from.name != "facturacion") {
        _.init();
      }
    });
  }
};
</script>
<style scoped=""></style>
